import React from "react";

import Table from "../common/Table";
import { Link } from "react-router-dom";

const FacultiesResultList = ({ data, query }) => {
  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "class_desc",
      label: "صنف",
      content: (e) => (
        <Link to={`/mis/results/${e.faculty_id}/${e.class_id}`}>
          {e.class_desc}
        </Link>
      ),
    },
    { path: "class_status", label: "وضعیت" },
    { path: "student_count", label: "تعداد محصلین" },
    { path: "passed", label: "کامیاب" },
    { path: "failed", label: "ناکام" },
    { path: "option" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default FacultiesResultList;
